// extracted by mini-css-extract-plugin
module.exports = {"component":"BorderContent_component__msDA6"};